export type PositionLoaderData = {
    position: PositionLoader;
    flag: boolean;
};

export enum PositionLoader {
    center = 'center',
    right = 'right',
}
